module.exports = __webpack_public_path__ + "img/howitworks2.9f6d7be1.png";